import { FC } from "react";
import classNames from "classnames";

import styles from "./Icon.module.css";

interface IconProps {
    name: 'left' | 'right' | 'close' | 'done' | 'geo' | 'down' | 'loader' | 'up' | 'watch';
    className?: string;
    onClick?: () => void;
}

export const Icon: FC<IconProps> = ({ name, className, onClick }) => {
    return (
        <span className={classNames(styles.icon, styles[name], className)} onClick={onClick} />
    )
}